import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MerchantUserModel } from "../models/merchantUser";

interface UserInterface {
  data: MerchantUserModel | null;
  loggedIn: boolean;
}

const initialState: UserInterface = {
  data: null,
  loggedIn: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginFailed: (state: UserInterface) => {
      state.data = null;
      state.loggedIn = true;
    },
    loginSuccess: (
      state: UserInterface,
      action: PayloadAction<MerchantUserModel>
    ) => {
      state.data =action.payload;
      state.loggedIn = true;
    },
    logout: (state: UserInterface) => {
      localStorage.clear();
      window.location.href = "/";
      state.data = null;
      state.loggedIn = false;
    },
  },
});

export const { loginSuccess, logout, loginFailed } = authSlice.actions;
export default authSlice.reducer;
